var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarFilter = function SvgCalendarFilter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.355 136.45H102.575C94.3073 136.45 87.605 143.152 87.605 151.42V340.77C87.605 349.038 94.3073 355.74 102.575 355.74H423.355C431.623 355.74 438.325 349.038 438.325 340.77V151.42C438.325 143.152 431.623 136.45 423.355 136.45Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.605 355.74L409.735 402.19C408.725 410.2 401.405 415.88 393.385 414.87L74.465 374.56C66.455 373.55 60.775 366.23 61.785 358.21L87.445 155.16L87.615 155.18",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.315 136.45C103.665 132.73 103.315 128.77 103.315 124.66C103.315 102.77 113.225 85.02 125.455 85.02C137.685 85.02 147.595 102.77 147.595 124.66C147.595 146.55 137.685 164.3 125.455 164.3",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.315 136.45C371.665 132.73 371.315 128.77 371.315 124.66C371.315 102.77 381.225 85.02 393.455 85.02C405.685 85.02 415.595 102.77 415.595 124.66C415.595 146.55 405.685 164.3 393.455 164.3",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.985 136.45C282.335 132.73 281.985 128.77 281.985 124.66C281.985 102.77 291.895 85.02 304.125 85.02C316.355 85.02 326.265 102.77 326.265 124.66C326.265 146.55 316.355 164.3 304.125 164.3",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.655 136.45C193.005 132.73 192.655 128.77 192.655 124.66C192.655 102.77 202.565 85.02 214.795 85.02C227.025 85.02 236.935 102.77 236.935 124.66C236.935 146.55 227.025 164.3 214.795 164.3",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.935 233.11H125.465V234.11H192.935V233.11Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M304.415 233.11H236.945V234.11H304.415V233.11Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M406.955 233.11H339.485V234.11H406.955V233.11Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.935 297.85H125.465V298.85H192.935V297.85Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M304.415 297.85H236.945V298.85H304.415V297.85Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.955 297.85H339.485V298.85H406.955V297.85Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/calendar-filter.svg";